export default function readingProgress() {
    const bar = document.querySelector("[data-reading-progress]");
    if (!bar) return;

    const article = document.querySelector(".post-content");
    if (!article) return;

    function update() {
        const rect = article.getBoundingClientRect();
        const articleTop = rect.top + window.scrollY;
        const articleHeight = rect.height;
        const viewportHeight = window.innerHeight;
        const scrollY = window.scrollY;

        const scrollableDistance = articleHeight - viewportHeight;
        if (scrollableDistance <= 0) {
            bar.style.transform = `scaleX(1)`;
            return;
        }

        const progress = Math.min(
            1,
            Math.max(0, (scrollY - articleTop) / scrollableDistance)
        );

        bar.style.transform = `scaleX(${progress})`;
    }

    window.addEventListener("scroll", update, { passive: true });
    update();
}
